import FrequencyDurationV1 from "../../../../components/form_builder/elements/frequency_duration/FrequencyDurationV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-frequency-duration-v1",
  component: FrequencyDurationV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      frequencyFirstOptions: [
        "Once",
        "Twice",
        "3 times",
        "4 times",
        "5 times",
        "1-3 times",
        "1-4 times",
        "2-8 times"
      ],
      frequencySecondOptions: [
        "per day",
        "per week",
        "per month",
        "per session",
        "per shift",
        "per minute",
        "per hour",
        "per morning"
      ],
      durationOptions: ["forever", "1 week", "1 month", "6 months", "1 year"],
      description: "",
      value: "",
      required: false,
      hidden: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) => value
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    return errors;
  }
};
